
import axios from 'axios';
import { getToken, clearToken } from './utils/token';
import { saveRedirectPath } from './utils/redirectAfterLogin';
import { Capacitor } from '@capacitor/core';

const baseURL = Capacitor.isNativePlatform()
  ? 'https://vaquit.app/api'
  : '/api';

const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const excludedPaths = ['/auth/register', '/auth/login'];
  const isExcluded = excludedPaths.some(path => config.url?.includes(path));
  if (!isExcluded) {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      localStorage.removeItem('userId');
      saveRedirectPath(window.location.pathname + window.location.search);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
